import { render } from "./TagCreate.vue?vue&type=template&id=3828939a"
import script from "./TagCreate.vue?vue&type=script&lang=js"
export * from "./TagCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__